import React from "react";

import {
    Cutout,
    TextField,
    Fieldset
} from 'react95';

export const Slide = ({ item, index, currentIndex }) => {
    return (     
        <div className={index === currentIndex ? "row no-gutters" : "d-none"}>
            <div className="col-md-3 col-12">
                <Cutout >
                    <img
                        style={{ width: '100%', height: 'auto', display: 'block' }}
                        src={item.src}
                        alt='kiwi'
                    />
                </Cutout>
            </div>
            <div className="col-md-9 col-12">
                <Fieldset label='About project' className="m-3">
                    <span>{item.text}</span>
                </Fieldset>
                
                <TextField
                    id='disabled'
                    variant='flat'
                    placeholder={item.tech}
                    disabled
                    className="m-3"
                >

                </TextField>
            </div>


        </div>
    );
};